/*
  Copyright Epic Games, Inc. All Rights Reserved.
*/

import { isError } from "@epic-mw/error-types";

import { getApiPath } from "../utils";

export interface AuthRes {
	bearerTokenValid: boolean;
	clearedOffline: boolean;
	accountId: string;
	upgradedBearerToken: boolean;
}

export const auth = async (serverUrl?: string): Promise<AuthRes> => {
	try {
		console.log("auth", { serverUrl: `${getApiPath(serverUrl)}/auth` });
		const response = await fetch(`${getApiPath(serverUrl)}/auth`);
		const json: AuthRes = await response.json();
		return json;
	} catch (err) {
		console.error("auth() failed to load", isError(err) && err.message);
		throw err;
	}
};
